var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.isAuthenticated)?_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('v-icon',[_vm._v(" mdi-logout ")]),_vm._v(" Log out ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }